import styled from '@emotion/styled/macro';
import { BaseButton } from '@enter/core';

export const DialogBody = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 24px;
    flex-grow: 1;
`;

export const InputRow = styled.div`
    display: flex;
    flex-direction: row;
    overflow-x: hidden;
    overflow-y: auto;
`;

export const InputColumn = styled.div`
    display: flex;
    flex-direction: column;
`;

export const Message = styled.div`
    flex-grow: 1;
    text-align: center;
    margin-bottom: 24px;
`;

export const Button = styled(BaseButton)`
    align-self: flex-end;
    margin: 16px 0;
`;
